var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.7,374.2H81.2V115h172.8v-43.2H81.2c-24,0-43.2,19.2-43.2,43.2v259.2c0,23.8,19.2,43.2,43.2,43.2h86.4v43.2h172.8v-43.2h86.4c23.8,0,43.2-19.4,43.2-43.2v-64.8h-43.2v64.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366,51.4l-108,108,30.5,30.5,55.9-55.7v154.9h43.2v-154.9l55.9,55.7,30.5-30.5-108-108Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.ee346cb3c8ee2e6b0d04c807e1bfb21f.svg";
export { ForwardRef as ReactComponent };